export default __webpack_public_path__ + "static/media/ROM EXAM PATTERN 2025 (CLASS - 7).dbe62ce0.pdf";